var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 156"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 125",
    x: 22.8984,
    y: 13.707,
    width: 7,
    height: 1,
    transform: "rotate(135 22.8984 13.707)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 126",
    x: 17.9492,
    y: 18.6582,
    width: 7,
    height: 1,
    transform: "rotate(-135 17.9492 18.6582)",
    fill: "#686868"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow_down_icon.d0e1cef13fc5a2e4db709a5a84293c2f.svg";
export { ForwardRef as ReactComponent };